import React from 'react';
import { Box, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATHS } from '../../routes/paths';

function getActiveTab(pathname = '') {
  if (pathname.startsWith(PATHS.adminStats)) return 'stats';
  if (pathname.startsWith(PATHS.adminServiceLinks)) return 'serviceLinks';
  if (pathname.startsWith(PATHS.adminUsers)) return 'users';
  return 'users';
}

const AdminTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const active = getActiveTab(location?.pathname || '');

  return (
    <Box sx={{ mt: 3, mb: 1.5 }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          border: '1px solid #c4c4c4',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Button
          fullWidth
          onClick={() => navigate(PATHS.adminUsers)}
          sx={{
            height: '45px',
            borderRadius: 0,
            bgcolor: active === 'users' ? '#103c85' : 'white',
            color: active === 'users' ? 'white' : 'black',
            fontWeight: 'bold',
            fontSize: '1rem',
            '&:hover': {
              bgcolor: active === 'users' ? '#103c85' : '#f5f5f5',
            },
          }}
        >
          회원관리
        </Button>
        <Button
          fullWidth
          onClick={() => navigate(PATHS.adminServiceLinks)}
          sx={{
            height: '45px',
            borderRadius: 0,
            borderLeft: '1px solid #c4c4c4',
            bgcolor: active === 'serviceLinks' ? '#103c85' : 'white',
            color: active === 'serviceLinks' ? 'white' : 'black',
            fontWeight: 'bold',
            fontSize: '1rem',
            '&:hover': {
              bgcolor: active === 'serviceLinks' ? '#103c85' : '#f5f5f5',
            },
          }}
        >
          이동 주소 관리
        </Button>
        <Button
          fullWidth
          onClick={() => navigate(PATHS.adminStats)}
          sx={{
            height: '45px',
            borderRadius: 0,
            borderLeft: '1px solid #c4c4c4',
            bgcolor: active === 'stats' ? '#103c85' : 'white',
            color: active === 'stats' ? 'white' : 'black',
            fontWeight: 'bold',
            fontSize: '1rem',
            '&:hover': {
              bgcolor: active === 'stats' ? '#103c85' : '#f5f5f5',
            },
          }}
        >
          통계관리
        </Button>
      </Box>
    </Box>
  );
};

export default AdminTabs;


